import React, { useEffect } from 'react'
import Drawer from '../../../components/common/Drawer'
import { useForm } from 'react-hook-form'
import Input from '../../../components/form/input/InputField'
import Label from '../../../components/form/Label'
import toast from 'react-hot-toast'
import { api } from '../../../configs/api'
import { useBusiness } from '../../../context/BusinessContext'
import Modal from '../../../components/common/Modal'

const PipelineDelete = ({ open, handleClose }: { open: boolean; handleClose: () => void }) => {
    const { business, currentTab } = useBusiness()
    const form = useForm({ mode: 'onChange' })
    const formRef = React.useRef<HTMLFormElement>(null)
    const currentPipeline = business.pipelines.find((pipeline: any) => pipeline.value === currentTab)

    const updatePipelineContext = () => {
        //! Remove o pipeline atual do contexto
        business.pipelines = business.pipelines.filter((pipeline: any) => pipeline.value !== currentTab)

        if (business.pipelines.length) {
            business.pipelines = business.pipelines.map((pipeline: any, index: number) => ({
                ...pipeline,
                value: index + 1
            }))
        }
    }

    const handleDelete = async () => {
        const id = currentPipeline?.id

        if (!currentPipeline || !id) {
            toast.error('Pipeline não encontrado!')
            return
        }

        try {
            const response = await fetch(`${api}business/deletePipeline`, {
                method: 'POST',
                body: JSON.stringify({ pipelineID: id })
            })
            const result = await response.json()

            if (!result.success) {
                toast.error('Não foi possível excluir o pipeline!')
                return
            }

            updatePipelineContext()

            toast.success('Pipeline excluído com sucesso!')
        } catch (error) {
            console.log(error)
        } finally {
            handleClose()
        }
    }

    if (!open) return null

    return (
        <Modal
            open={open}
            handleClose={handleClose}
            title='Excluir Pipeline'
            maxWidth='max-w-xl'
            handleDelete={() => formRef.current?.requestSubmit()}
            canDelete
        >
            <form ref={formRef} onSubmit={form.handleSubmit(handleDelete)}>
                <p className='text-gray-800 dark:text-white/90 text-sm'>
                    Tem certeza que deseja exluir o pipeline{' '}
                    <strong className='text-error-400'>{currentPipeline?.label}</strong> ?
                </p>
            </form>
        </Modal>
    )
}

export default PipelineDelete
